module.exports = __webpack_public_path__ + "static/tom-e28fa8e2c023e99000c0502757140136.png";